export default {
    name: 'Ism',
    tel: 'Telefon',
    save: 'Saqlash',
    confirm: 'Tasdiqlash',
    cancel: 'Bekor qilish',
    delete: 'Oʻchirish',
    complete: 'Tugatish',
    loading: 'Yuklanmoqda...',
    telEmpty: 'Iltimos, telefon raqamini kiriting',
    nameEmpty: 'Iltimos, ismni kiriting',
    nameInvalid: 'Notoʻgʻri ism formati',
    confirmDelete: 'Haqiqatan ham oʻchirmoqchimisiz?',
    telInvalid: 'Notoʻgʻri telefon raqami',
    vanCalendar: {
      end: 'Tugash',
      start: 'Boshlanish',
      title: 'Taqvim',
      startEnd: 'Boshlanish/Tugash',
      weekdays: ['Yak', 'Dush', 'Sesh', 'Chor', 'Pay', 'Jum', 'Shan'],
      monthTitle: function monthTitle(year, month) {
        return year + "/" + month; // Format saqlangan
      },
      rangePrompt: function rangePrompt(maxRange) {
        return maxRange + " kundan koʻp boʻlmagan kunni tanlang";
      }
    },
    vanCascader: {
      select: 'Tanlash'
    },
    vanContactCard: {
      addText: 'Kontakt maʼlumotini qoʻshish'
    },
    vanContactList: {
      addText: 'Yangi kontakt qoʻshish'
    },
    vanPagination: {
      prev: 'Oldingi',
      next: 'Keyingi'
    },
    vanPullRefresh: {
      pulling: 'Yangilash uchun torting...',
      loosing: 'Yangilash uchun qoʻyib yuboring...'
    },
    vanSubmitBar: {
      label: 'Jami:'
    },
    vanCoupon: {
      unlimited: 'Cheksiz',
      discount: function discount(_discount) {
        return _discount * 10 + "% chegirma";
      },
      condition: function condition(_condition) {
        return "Kamida " + _condition;
      }
    },
    vanCouponCell: {
      title: 'Kupon',
      tips: 'Kuponlar mavjud emas',
      count: function count(_count) {
        return "Sizda " + _count + " ta kupon mavjud";
      }
    },
    vanCouponList: {
      empty: 'Kuponlar mavjud emas',
      exchange: 'Almashtirish',
      close: 'Yopish',
      enable: 'Mavjud',
      disabled: 'Mavjud emas',
      placeholder: 'Kupon kodi'
    },
    vanAddressEdit: {
      area: 'Hudud',
      postal: 'Pochta indeksi',
      areaEmpty: 'Iltimos, qabul qilish hududini tanlang',
      addressEmpty: 'Manzil boʻsh boʻlishi mumkin emas',
      postalEmpty: 'Notoʻgʻri pochta indeksi',
      defaultAddress: 'Standart manzil sifatida oʻrnatish',
      telPlaceholder: 'Telefon',
      namePlaceholder: 'Ism',
      areaPlaceholder: 'Hudud'
    },
    vanAddressEditDetail: {
      label: 'Manzil',
      placeholder: 'Manzil'
    },
    vanAddressList: {
      add: 'Yangi manzil qoʻshish'
    }
  };